import React from "react";
import PropTypes from "prop-types";
import ListView from "components/common/ListView";
import MaterialIcon from "components/common/MaterialIcon";
import { index } from "../../../Basic/Category/Module";
import store from "store";
import { connect } from "react-redux";

@connect((state) => ({}), {
  index,
})
@autobind
@autobind
/**
 *
 * @class ReportsList
 * @extends PureComponent
 */
export default class ReportsList extends React.PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    activeItem: PropTypes.number,
    onSearch: PropTypes.func,
    onClick: PropTypes.func,
    reference: PropTypes.func,
    menu: PropTypes.func,
    extra: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    loading: PropTypes.bool,
    pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  };
  constructor(props) {
    super(props);
    this.state = { newItems: [] };
  }
  static defaultProps = {
    items: [],
    loading: true,
    pagination: {},
    reference: (input) => {},
  };

  componentDidMount() {
    store.dispatch(
      index({ page: 0, limit: 20 }, (res) => this.setState({newItems: this.props.items}))
    );
  }
  componentDidUpdate(prevProps, prevState) {
    const { items } = this.props;
    if ( items !== prevProps.items) {
      if(!app.haveUiPermission(["Arrpa"])){
        const newItems = items.filter((i) => i.id !== 225);
        this.setState({ newItems: newItems });
        return;
      }else{
        this.setState({ newItems: items });
      }
    }
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const {
      items,
      activeItem,
      onSearch,
      onClick,
      menu,
      extra,
      loading,
      pagination,
      reference,
      ...rest
    } = this.props;
    console.log("isdfsdftems", items);

    return (
      <ListView
        ref={reference}
        title={app.translate("routes.Reports")}
        items={this.state.newItems}
        primaryText={(item) =>
          `${app.translate("routes.home.attendance.reports.Report")} ${
            item.label
          }`
        }
        secondaryText={"description"}
        style={{ height: "100%" }}
        activeItem={activeItem}
        onSearch={onSearch}
        onClick={onClick}
        menu={menu}
        extra={extra}
        loading={loading}
        pagination={pagination}
        icon={true}
        {...rest}
      />
    );
  }
}
